import {useEffect} from "react";

type Props = {
    visible: boolean;
    position: { top: number; right: number } | null;
    selectedCount: number;
    onApply: () => void;
    onClose: () => void;
};

export default function FilterApplyBar({position, onApply, onClose, visible, selectedCount}: Props) {
    // close when clicking outside
    useEffect(() => {
        const close = () => onClose();
        window.addEventListener("click", close);
        return () => window.removeEventListener("click", close);
    }, [onClose]);

    return (
        <div
            style={position ? {
            top: position.top + 60,
            right: position.right,          // align left edge of bar to left edge of filter section
        } : undefined}
            className={`absolute z-50 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10 pointer-events-none"}`}
            onClick={(e) => e.stopPropagation()} // prevent closing when clicking popup
        >
            <div className="bg-white shadow-2xl rounded-xl px-6 py-4 flex items-center gap-6 border">

                {/* left side */}
                <div className="flex items-center gap-3">
                    <button
                        onClick={onClose}
                        className="w-8 h-8 rounded-full border flex items-center justify-center text-gray-500 hover:bg-gray-100"
                    >
                        ✕
                    </button>

                    <span className="text-gray-700">
            Found <span className="font-semibold">{selectedCount}</span> phones
          </span>
                </div>

                {/* apply button */}
                <button
                    onClick={onApply}
                    className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-lg font-semibold transition"
                >
                    Show ↓
                </button>
            </div>
        </div>
    );
}
